import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
    selector: 'e-queries-free-text-question',
    template: require('./e-queries-free-text-question.component.html'),
    styles: [require('./e-queries-free-text-question.component.scss')]
})
export class EQueriesFreeTextQuestionComponent {
    @Input()
    public questionText: string;

    @Input()
    public mask: string;

    @Input()
    public maskDescription: string;

    @Input()
    public textMaxBytes: number;

    @Input()
    public freeTextControl: FormControl;

    constructor() {}

    public meetResponseMask() {
        if (!this.mask) { return true; }
        const currentText = this.freeTextControl.value;
        // if value is null or whitespace
        if (!currentText) { return true; }
        const currentTextTrimmed = currentText.toString().trim();
        const regParts = this.mask.match(/^\/(.*?)\/([gim]*)$/);
        let mask = undefined;
        let isGlobal = true;
        if (regParts) {
            mask = new RegExp(regParts[1], regParts[2]);
            isGlobal = regParts[2] === 'g';
        } else {
            mask = new RegExp(this.mask, 'g');
        }
        // Add flag 'g' to avoid entering extra characters
        // Returns the first match and remembers the position after it in the mask.lastIndex property
        const maskExecResult = mask.exec(currentTextTrimmed);
        // If no matches found
        if (!maskExecResult) { return false; }
        // If a match is found, but there are extra characters at the beginning of the text
        if (maskExecResult.index !== 0) {return false; }
        // Returns true if a match is found and there are no extra characters at the end of the text
        return isGlobal ? mask.lastIndex === currentTextTrimmed.length : true;
    }
}
